// Small wrapper around DeepgramStreamingEngine for one-shot dictation into
// the BugReportButton textarea. Independent from the leads ASR flow so it
// can be started/stopped without touching transcript/extraction state.
//
// Gated by the caller (BugReportButton only renders the mic button for
// canQueueDevSyncNotes(auth) — platform_owner / platform_dev).
//
// Plan: dev sync note 816024b6 ("mic listener and transcription ability
// for the report a bug feature").

import { useDeepgramHoldMic } from "@/lib/asr/useDeepgramHoldMic";
import type { DeepgramHoldMicStatus } from "@/lib/asr/deepgramHoldMicSession";

export type BugReportMicStatus = DeepgramHoldMicStatus;

export type UseBugReportMicResult = {
  status: BugReportMicStatus;
  error: string | null;
  start: () => Promise<void>;
  stop: () => Promise<void>;
};

export function useBugReportMic(onAppend: (chunk: string) => void): UseBugReportMicResult {
  return useDeepgramHoldMic({ onAppend });
}
